<template>
  <div class="js-basedata-cargroup app-container">
    <!-- 查询 -->
    <app-search>
      <div slot="content">
        <el-form
          :model="listQuery"
          label-suffix="："
          :label-width="$t('geofence.style.queryLabelWidth')"
        >
          <el-row :gutter="10">
            <el-col :span="6">
              <el-form-item :label="$t('geofence.geofenceName')">
                <el-input
                  v-model="listQuery.ruleName"
                  clearable
                  :placeholder="$t('geofence.geofenceName')"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item
                :label="$t('carMonitor.electric.electricNotes.alarmType')"
              >
                <el-select
                  v-model="listQuery.alarmType"
                  clearable
                  :placeholder="
                    $t('carMonitor.electric.electricNotes.alarmType')
                  "
                >
                  <el-option
                    v-for="(item, index) in alarmTypeList"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <app-search-button
        slot="bottom"
        :is-collapse="false"
        @click-filter="handleFilter"
        @click-clear="handleClear"
      />
    </app-search>
    <!-- 按钮 -->
    <app-authorize-button
      :data="authouizeList"
      @click-add="handleAdd"
      @click-update="handleUpdate"
      @click-delete="handleDelete"
      @click-import="importConfig.visible = true"
      @click-filter="showfilter = true"
    >
      <checked-Filter
        slot="check-filter"
        :show.sync="showfilter"
        :list="tableList"
        :scroll-line="8"
      />
    </app-authorize-button>
    <!-- table -->
    <el-table
      ref="multipleTable"
      v-loading="listLoading"
      size="mini"
      :data="list"
      :max-height="tableHeight"
      border
      fit
      highlight-current-row
      style="width: 100%"
      :header-row-style="headerRowStyle"
      :row-style="rowStyle"
      :header-cell-style="headerCellStyle"
      @current-change="handleCurrentRowChange"
      @sort-change="sortChange"
    >
      <el-table-column
      :selectable="checkboxT"
      type="selection"
      width="55">
    </el-table-column>
      <el-table-column :label="$t('table.id')" align="center" width="65">
        <template slot-scope="scope">
          <span>{{
            scope.$index + 1 + (listQuery.pageNum - 1) * listQuery.pageSize
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        v-for="(item, index) in filterTableList"
        :key="index"
        :label="item.value"
        :prop="item.prop"
        :align="item.position"
        :min-width="item.width"
        :sortable="item.sortable"
      >
        <template slot-scope="scope">
          <el-button
            v-if="item.prop === 'carCount'"
            @click.native.prevent="viewVehicle(scope.row)"
            type="text"
            size="small"
          >
            {{ scope.row[item.prop] }}
          </el-button>
          <div v-else-if="item.prop === 'alarmType'">
            <span
              :style="{
                color:
                  scope.row[item.prop] == 1
                    ? 'teal'
                    : scope.row[item.prop] == 0
                    ? '#FF0000'
                    : '',
              }"
              >{{ scope.row[item.prop] | switchText(item.prop) }}</span
            >
          </div>
          <div v-else-if="item.prop === 'readOnly'">
            <span>{{ scope.row[item.prop] | switchText(item.prop) }}</span>
          </div>
          <div v-else>
            {{ scope.row[item.prop] | switchText(item.prop) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        :label="$t('public.operation')"
        width="100px"
        align="center"
      >
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="handleView(scope.row)">
            {{ $t("public.view") }}
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <div :class="[total > 0 ? 'visible' : 'hidden', 'pagination-container']">
      <el-pagination
        :current-page="listQuery.pageNum"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="listQuery.pageSize"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <add-dialog
      :visible.sync="addUpdateVisible"
      :is-edit="isEdit"
      :data="currentRow"
      @add-complete="listLoad"
      @update-complete="listLoad"
    />
    <view-vehicle-list
      :visible.sync="viewVehicleVisible"
      :id="viewVehicleVisible ? currentRow.ruleId : null"
    />
    <view-geofence :visible.sync="viewGeofenceVisible" :data="currentRow" />
    <!-- 导出弹窗 -->
    <import-dialog
      :action="importConfig.url"
      :template-url="importConfig.template"
      :visibles.sync="importConfig.visible"
      @upload-success="reloadList"
    >
      <result-dialog
        :visibles.sync="importConfig.resultVisible"
        :data="importConfig.result"
        :text="importConfig.text"
        :keys="'licensePlate'"
        :message="
          $t('baseData.terminalmanage.terminalInfo.message.noImportInfo')
        "
        :is-show="importConfig.visible"
      >
      </result-dialog>
    </import-dialog>
  </div>
</template>

<script>
// 混入
import { partialForm } from '@/mixins/partialForm'
import { pagingMixin } from '@/mixins/table'
import { otherHeight } from '@/mixins/getOtherHeight'
import { tableStyle } from '@/mixins/tableStyle'
import { getPageButton } from '@/mixins/getButton'
// 组件
import AddDialog from './components/addDialog'
import ViewVehicleList from './components/viewVehicleList'
import ViewGeofence from './components/viewGeofence'
import importDialog from '@/components/importDialog'
import resultDialog from '@/components/resultDialog'
// import ruleDialog from './components/ruleDialog'
// import detailCarDialog from './components/detailCarDialog'
// request
import { listUrl, deleteUrl,deleteUrlBatch, importGefenceUrl } from '@/api/electric/geofence'
import resolve from '@/api/resolve'

let ruleTypeList
export default {
  name: 'geofence',
  components: { AddDialog, ViewVehicleList, ViewGeofence, importDialog, resultDialog },
  filters: {
    switchText(val, type) {
      switch (type) {
        case 'alarmType':
          {
            const strs = vm.$t('geofence.out') + "&" + vm.$t('geofence.in')
            return val === '0' ? vm.$t('geofence.out') : val === '1' ? vm.$t('geofence.in') : val === '0,1' ? strs : ''
          }
        case 'ruleType':
          return ruleTypeList[val].label
        case 'readOnly':
          return val === 1 ? vm.$t('carMonitor.electric.electricManage.readOnly') : vm.$t('carMonitor.electric.electricManage.editable')
        default:
          return val || '/'
      }
    }
  },
  mixins: [pagingMixin, partialForm, otherHeight, tableStyle, getPageButton],
  data() {
    const data = {
      listQuery: {
        ruleName: '',
        alarmType: '',
        beginTime: '',
        endTime: '',
        // alarmTypeArry:[],
      },
      showfilter: false,
      alarmTypeList: [
        { label: this.$t('geofence.out'), value: 0 },
        { label: this.$t('geofence.in'), value: 1 },
        { label: this.$t('geofence.out') + '&' + this.$t('geofence.in'), value: '0,1' }
      ],
      ruleTypeList: [
        { label: this.$t('geofence.shape.polygon'), value: 0 },
        { label: this.$t('geofence.shape.rectangle'), value: 1 },
        { label: this.$t('geofence.shape.circle'), value: 2 }
      ],
      tableList: [
        { value: this.$t('carMonitor.electric.electricNotes.ruleName'), prop: 'ruleName', position: 'center', sortable: 'custom', checked: true },
        { value: this.$t('carMonitor.electric.electricManage.rulestype'), prop: 'ruleType', position: 'center', sortable: 'custom', checked: true },
        { value: this.$t('carMonitor.electric.electricNotes.alarmType'), prop: 'alarmType', position: 'center', sortable: 'custom', checked: true },
        { value: this.$t('carMonitor.electric.electricManage.alarmVehicle'), prop: 'carCount', position: 'center', checked: true },
        { value: this.$t('carMonitor.electric.electricManage.createdByYou'), prop: 'readOnly', position: 'center', checked: true },
        { value: this.$t('carMonitor.electric.electricManage.createdon'), prop: 'createdOn', position: 'center', sortable: 'custom', checked: true }
      ],
      tableHeight: 0,
      total: 0,
      list: [],
      listLoading: false,
      addUpdateVisible: false,
      isEdit: false,
      currentRow: null,
      carcountVisible: false, // 车辆明细
      ruleVisible: false, // 规则明细
      viewVehicleVisible: false,
      viewGeofenceVisible: false,
      importConfig: {
        visible: false,
        url: importGefenceUrl,
        template: '/file/upload/template/importGeofence.xlsx',
        text: this.$t('public.licensePlate'),
        resultVisible: false
      }
    }
    ruleTypeList = data.ruleTypeList
    return data
  },
  computed: {
    filterTableList() {
      return this.tableList.filter(item => item.checked)
    }
  },
  methods: {
    // 加载数据
    listLoad() {
      this.listLoading = true
      // this.listQuery.alarmType = this.listQuery.alarmTypeArry.toString()
      this.$http.post(listUrl, this.listQuery).then(({ data }) => {
        this.list = []
        if (data.code === 0) {
          this.list = data.data
          this.total = data.total
        }
      }).finally(() => {
        this.listLoading = false
      })
    },
    //禁用部分无权限的勾选框
    checkboxT(row){
      if(row.readOnly==1){
        return false
      }else {
        return true
      }
    },
    // 新增
    handleAdd() {
      this.isEdit = false
      this.addUpdateVisible = true
    },
    // 编辑
    handleUpdate() {
      if (!this.checkCurrentRowEmpty()) {
        if (!this.currentRow.readOnly) {
          this.isEdit = true
          this.addUpdateVisible = true
        } else {
          this.$alert(this.$t('carMonitor.electric.electricManage.readOnlyTip'),
            this.$t('public.tips'), {
            confirmButtonText: this.$t('public.define')
          })
        }
      } else {
        this.$alert(this.$t('public.updateTips'), this.$t('public.tips'), {
          confirmButtonText: this.$t('public.define')
        })
      }
    },
    // 删除
    handleDelete() {
      let selection=this.$refs.multipleTable.selection
      if(selection.length!==0){
          //有多选框勾选
          let ruleIds = selection.map((s)=>{
              return s.ruleId
          })
          this.$confirm(this.$t('public.deleteItemTips'), this.$t('public.tips'), {
            confirmButtonText: this.$t('public.define'),
            cancelButtonText: this.$t('public.cancel'),
            type: 'warning'
          }).then(()=>{
              //批量删除
              this.$http.post(deleteUrlBatch,ruleIds).then(({ data }) => {
              if (data.code === 0) {
                this.listLoad()
                this.$message.success({
                  message: this.$t('public.deleteSuccess'),
                  duration: 2 * 1000
                })
              }
            })
          })
      }else if(this.checkCurrentRowEmpty() && selection.length==0){
        this.$alert(this.$t('public.deleteTips'), this.$t('public.tips'), {
          confirmButtonText: this.$t('public.define')
        })
        return
      }else{
        if (this.checkCurrentRowEmpty()) {
          this.$alert(this.$t('public.deleteTips'), this.$t('public.tips'), {
            confirmButtonText: this.$t('public.define')
          })
          return
        }
        if (this.currentRow.readOnly) {
          this.$alert(this.$t('carMonitor.electric.electricManage.readOnlyTip'),
            this.$t('public.tips'), {
            confirmButtonText: this.$t('public.define')
          })
        } else {
            this.$confirm(this.$t('public.deleteItemTips'), this.$t('public.tips'), {
            confirmButtonText: this.$t('public.define'),
            cancelButtonText: this.$t('public.cancel'),
            type: 'warning'
          })
            .then(() => {
              //常规删除
              this.$http.delete(resolve(deleteUrl, this.currentRow.ruleId)).then(({ data }) => {
                if (data.code === 0) {
                  this.listLoad()
                  this.$message.success({
                    message: this.$t('public.deleteSuccess'),
                    duration: 2 * 1000
                  })
                }
              })
            })
        }
      }
      
    },
    viewVehicle(row) {
      this.currentRow = row
      this.viewVehicleVisible = true
    },
    handleView(row) {
      this.currentRow = row
      this.viewGeofenceVisible = true
    },
    /**
     * 检测是否未选择
     */
    checkCurrentRowEmpty() {
      return !this.currentRow
    },
    handleCurrentRowChange(val) {
      this.currentRow = val
    },
    // 规则明细
    handleAudit(row) {
      this.currentRow = row
      this.ruleVisible = true
    },
    // 导入成功之后刷新list
    reloadList(data) {
      this.importConfig.result = data
      this.importConfig.resultVisible = true
      this.listLoad()
    }

  }
}
</script>

<style lang='scss'>
.set-input-padding input {
  padding-right: 10px !important;
}
.licensePlateColor {
  color: #409eff;
  border-bottom: 1px solid #409eff;
  cursor: pointer;
}
</style>
